import React from 'react'

import Select from 'react-select'

import { hideSystemMessages } from '@/client/generalSlice'
import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { useGetStaffUsersQuery } from '@/services/user'
import { getUserFullNameOrEmail } from '@/utils/user'

export function StreamingNotesFilters({ ...props }) {
  const { onSelectUser } = props
  const dispatch = useAppDispatch()
  const systemMessagesHidden = useAppSelector((state) => state.general.hideSystemMessages)
  const { data: staffUsers, isLoading: isLoadingStaffUsers } = useGetStaffUsersQuery()

  return (
    <details className='shadow-sm p-1'>
      <summary className='text-sm hover:cursor-pointer'>Filter</summary>
      <div className='border p-3 bg-gray-100'>
        <div className='form-control max-w-fit'>
          <div className='label'>
            <input
              type='checkbox'
              checked={systemMessagesHidden}
              onChange={() => dispatch(hideSystemMessages(!systemMessagesHidden))}
              className='checkbox mr-1'
            />
            <span className='label-text'>Hide System Messages</span>
          </div>
        </div>
        <hr className='my-3' />
        <div className='form-control w-full max-w-full'>
          <div className='label'>
            <span className='label-text'>Only show messages sent by:</span>
          </div>
          <Select
            placeholder='Select User'
            options={staffUsers?.map((user) => ({
              value: user.id,
              label: getUserFullNameOrEmail(user),
            }))}
            isLoading={isLoadingStaffUsers}
            onChange={onSelectUser}
            isClearable
          />
        </div>
      </div>
    </details>
  )
}
